import { ExclamationCircleIcon } from '@heroicons/react/24/solid';
import type { ReactNode } from 'react';

export type AlertType = 'warning' | 'error' | 'info';
export type Alert = { id: number; alert_message: ReactNode };

const errorTypeColorMap: Record<AlertType, string> = {
  warning: 'bg-status-action-required-active',
  error: 'bg-status-negative',
  info: 'bg-surface-selected'
};

type Props = {
  kind: AlertType;
  alerts?: Alert[];
  dataTestId?: string;
};

export function AlertBanner({ kind, alerts, dataTestId }: Props) {
  return (
    !!alerts?.length && (
      <div
        className={`flex justify-center gap-2 p-2 ${errorTypeColorMap[kind]} m-4 rounded-[20px]`}
        data-testid={dataTestId}
      >
        <ExclamationCircleIcon className="mt-1 size-4 shrink-0 rotate-180" />
        <div className="flex-col">
          {alerts.map((alert) => (
            <p key={alert.id} className="text-center">
              {alert.alert_message}
            </p>
          ))}
        </div>
      </div>
    )
  );
}
